// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2ozfL","noInteraction":"EventWrapper_noInteraction__lb-2j","pointerPassthrough":"EventWrapper_pointerPassthrough__1L9Mr"};